import React, { useContext, useState } from "react";
import SalesChart2 from "./GraficosVendasRechart";
import { DadosVendas } from "../Shared/Interfaces/DadosVendas";
import { FiltroRelatorio } from "../Shared/Interfaces/Pedido";
import { PedidoService } from "../../Services/PedidoService";
import { AppProvider } from "../../ContextApi/AppProvider";
import dayjs, { Dayjs } from "dayjs";
import "dayjs/locale/pt-br";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { Box } from "@mui/system";
import { Button, Grid, Paper, Typography } from "@mui/material";
import DefaultLoader from "../Shared/DefaultLoader";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import colors from "../../theme/colors";

export default function Graficos() {
  const contextApi = useContext(AppProvider);
  const pedidoService = new PedidoService();
  const [loading, setLoading] = useState(false);
  const [dados, setDados] = React.useState<DadosVendas | null>(null);
  const [dataInicial, setDataInicial] = useState<Dayjs>(
    dayjs().subtract(7, "day")
  );
  const [dataFinal, setDataFinal] = useState<Dayjs>(dayjs());

  const PesquisarPor = () => {
    setLoading(true);
    const filtroPesquisa: FiltroRelatorio = {
      dataInicial: dataInicial != null ? dataInicial.toISOString() : null,
      dataFinal: dataFinal != null ? dataFinal.toISOString() : null,
    };

    pedidoService
      .gerarRelatorioPedidos(filtroPesquisa)
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          setDados(response.data ?? null);
        }
      })
      .catch((error) => {
        const errorMessage = error.response?.data || "An error occurred";
        contextApi.showMessage(errorMessage, true, "error");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  React.useEffect(() => {
    PesquisarPor();
  }, []);

  return (
    <Box sx={{ flexGrow: 1, p: 2 }}>
      <Paper sx={{ p: 1 }}>
        <Grid container spacing={2}>
          {/* Linha 1 - Cabeçalho e Descrição 
          <Grid item xs={12}>
            <Paper sx={{ p: 1, bgcolor: '#f8f9fa' }}>
              <h4 style={{ margin: '0 0 0 0', color: colors.bluePrimary, textAlign: 'left' }}>
                📊 Dashboard de Vendas
              </h4>
              <Typography variant="body2" sx={{ color: '#666', mt: 1 }}>
                Análise detalhada das vendas e performance do negócio
              </Typography>
            </Paper>
          </Grid>
          */}

          {/* Linha 2 - Filtros de Data */}
          <Grid item xs={12}>
              <h4 style={{ margin: '0 0 20px 0', color: colors.bluePrimary }}>🗓️ Filtros de Período</h4>
              <LocalizationProvider
                dateAdapter={AdapterDayjs}
                adapterLocale="pt-br"
              >
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12} sm={6} md={3}>
                    <DemoContainer components={["DatePicker"]}>
                      <DatePicker
                        label="Data Inicial"
                        defaultValue={dataInicial}
                        value={dataInicial}
                        onChange={(newValue) =>
                          setDataInicial(newValue ?? dataInicial)
                        }
                        format="DD/MM/YYYY"
                        slotProps={{
                          textField: {
                            size: "small",
                            fullWidth: true,
                          },
                        }}
                      />
                    </DemoContainer>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <DemoContainer components={["DatePicker"]}>
                      <DatePicker
                        value={dataFinal}
                        onChange={(newValue) =>
                          setDataFinal(newValue ?? dataFinal)
                        }
                        label="Data Final"
                        format="DD/MM/YYYY"
                        slotProps={{
                          textField: {
                            size: "small",
                            fullWidth: true,
                          },
                        }}
                      />
                    </DemoContainer>
                  </Grid>
                  <Grid item xs={12} sm={6} md={1.5}>
                    <Button
                      variant="contained"
                      size="large"
                      disabled={loading}
                      sx={{ height: "40px", width: "100%" }}
                      onClick={() => PesquisarPor()}
                    >
                      {loading ? (
                        <DefaultLoader
                          height="2.5em"
                          width="2.5em"
                          colors={[
                            "#1876D2",
                            "#1876D2",
                            "#1876D2",
                            "#1876D2",
                            "#1876D2",
                          ]}
                          textInfo="Gerando Relatório..."
                        />
                      ) : (
                        "Pesquisar"
                      )}
                    </Button>
                  </Grid>
                </Grid>
              </LocalizationProvider>
          </Grid>

          {/* Linha 3 - Gráfico de Vendas */}
          <Grid item xs={12}>
                {dados ? (
                  <SalesChart2 data={dados} />
                ) : (
                  <Box sx={{ textAlign: "center", py: 8 }}>
                    <Typography variant="body2" sx={{ color: "text.secondary" }}>
                      Nenhum dado disponível para o período selecionado
                    </Typography>
                  </Box>
                )}
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
}
